/**
 * Random encouragement lines for Data Event with {{count}} substitution.
 */

const COUNT_PLACEHOLDER = /\{\{\s*count\s*\}\}/gi;

export function substituteEncouragementPlaceholders(template, { count }) {
  if (typeof template !== "string") return "";
  const n = Number.isFinite(Number(count)) ? Number(count) : 0;
  return template.replace(COUNT_PLACEHOLDER, String(n));
}

export function normalizeEncouragementMessages(content) {
  if (!content || typeof content !== "object") return [];
  const m = content.encouragementMessages;
  if (!Array.isArray(m)) return [];
  return m.filter((s) => typeof s === "string" && s.trim().length > 0);
}

export function pickRandomEncouragementMessage(messages) {
  if (!Array.isArray(messages) || messages.length === 0) return null;
  return messages[Math.floor(Math.random() * messages.length)];
}
